var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8029_5407)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.30469,
    y: 3.6897,
    width: 19.0635,
    height: 21.5233,
    rx: 9.53176,
    fill: "#0163FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0.000976562C6.26882 0.000976562 0 6.26857 0 14.0004C0 21.7322 6.26821 27.9997 14 27.9997C21.7324 27.9997 28 21.7322 28 14.0004C28 6.26857 21.7324 0.000976562 14 0.000976562ZM14 4.18696C16.5582 4.18696 18.6312 6.26057 18.6312 8.81755C18.6312 11.3751 16.5582 13.4481 14 13.4481C11.443 13.4481 9.37003 11.3751 9.37003 8.81755C9.37003 6.26057 11.443 4.18696 14 4.18696ZM13.9969 24.3396C11.4455 24.3396 9.10867 23.4104 7.30625 21.8724C6.86717 21.4979 6.61381 20.9487 6.61381 20.3725C6.61381 17.7792 8.71264 15.7038 11.3065 15.7038H16.6947C19.2892 15.7038 21.38 17.7792 21.38 20.3725C21.38 20.9493 21.1279 21.4972 20.6882 21.8718C18.8864 23.4104 16.549 24.3396 13.9969 24.3396Z",
    fill: "#EEF5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8029_5407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverPic);
export default __webpack_public_path__ + "static/media/driver-pic.12cbb24f774a0932af0b7028faca4b05.svg";
export { ForwardRef as ReactComponent };